var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.name)?_c('span',{staticClass:"material-icon",style:({ fontSize: ((this.size) + "px"), color: ("" + (this.color)) })},[_vm._v(_vm._s(this.name))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }